export default "<div class=\"form__message--error\">\n  <h2><%= title %></h2>\n  <p><%= message %></p>\n</div>\n"